import { useEffect } from "react";
import { getPlayerSimpleURL } from "../../../../../app/src/Utils/utils";

export default function ScriptEmbed({ id, isDetail = false, src, width, height }) {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = src || getPlayerSimpleURL(id, isDetail);
    script.async = true;

    const resolvedWidth = width ?? `${window.innerWidth}px`;
    script.setAttribute("data-width", resolvedWidth);

    if (height) {
      script.setAttribute("data-height", height);
    } else if (!width) {
      script.setAttribute("data-height", `${window.innerWidth / (16 / 9)}px`);
    }

    script.setAttribute("data-mini", "true");

    const container = document.querySelector(".Player");
    if (container) {
      container.appendChild(script);
    }

    return () => {
      if (container) {
        while (container.firstChild) {
          container.removeChild(container.firstChild);
        }
      }
    };
  }, [id]);

  return null; // nothing rendered directly
}
